export default __webpack_public_path__ + "static/img_product_popreader@2x-817ea83ef1e96963bc3ffa1d56f285da.png";